import React from "react";
import ReactDOM from "react-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <Auth0Provider
    domain="cooktopsafety.us.auth0.com"
    clientId="uQE1Hg4askKM0sqF6VniqjZzdROgphIk"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://api.cooktopsafety.com",
      scope: "offline_access openid email",
    }}
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
